module.exports = __webpack_public_path__ + "img/16l011-03.4fbb3589.jpg";